import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Layout } from 'antd';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import Breadcrumbs from '../../../components/LayoutComponents/Breadcrumbs';
import { getJson, API_URL } from '../../../helpers/api/api';
import ProjectForm, { Project } from '../../../components/CbsComponents/ProjectForm/ProjectForm';

interface EditSaleParams {
  id: string;
}
interface EditSaleProps {
  projectId: string;
}

const EditSale: React.FC<RouteComponentProps<EditSaleParams> &
  EditSaleProps &
  WrappedComponentProps> = ({ projectId, match, intl }) => {
  const { id } = match.params;
  const [data, setData] = useState<Project>();
  const [teamLeads, setTeamLeads] = useState<string[]>();
  const breadcrumbs = [
    {
      title: 'menu.projects',
      href: '/projects',
    },
    {
      title: id,
      href: `/projects/${id}`,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const project = await getJson(`${API_URL}/projects/${projectId}/projects/${id}`);
      const list = await getJson(`${API_URL}/projects/${projectId}/projects`);
      setTeamLeads(list.data);
      setData(project.data);
    };
    fetchData();
  }, [projectId, id]);

  if (!data || !teamLeads) return null;

  return (
    <Layout.Content style={{ height: '100%', position: 'relative' }}>
      <Helmet title={`${intl.formatMessage({ id: 'menu.projects' })} | ${id}`} />
      <div className="utils__content">
        <div style={{ marginBottom: '20px' }}>
          <div className="page-title">
            <FormattedMessage id="menu.projects" />
          </div>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
        <ProjectForm projectData={data} />
      </div>
    </Layout.Content>
  );
};

const mapStateToProps = (state: any) => {
  return {
    projectId: state.user.currentProjectId,
  };
};

export default connect(mapStateToProps)(injectIntl(EditSale));
